import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import Modal from './Modal';
import Pdf from './Pdf';
import { Api } from '../app-controller';

const host = window.location.host.split(":")[0];

const titleStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  height: '112px',
  textAlign: 'justify'
};

const hiddenStyle = {
  display: 'none'
};

const itemStyle = {
  border: '0px solid green',
  padding: '10px',
  margin: '0px',
  overflow: 'hidden',
  height: '145px'
};

CardPublications.propTypes = {
  contents: PropTypes.object
};

export default function CardPublications({ contents }) {
  const [modalShow, setModalShow] = useState(false);
  const windowWidth = window.innerWidth;

  const handleOpen = () => {
    setModalShow(true);
  };

  const handleClose = () => {
    setModalShow(false);
  };

  return (
    <Card sx={{ width: "180px" }} md={1}>
      {contents.imagen !== null ? (
        <CardMedia
          component="img"
          height="140"
          image={`${Api.url}getArchivo?id=${contents.id}`}
          alt={contents.titulo}
          style={windowWidth > 400 ? {} : hiddenStyle}
        />
      ) : null}
      <Box sx={contents.url_pdf !== null? itemStyle: hiddenStyle}>
        <Pdf urlPdf={`${Api.url}getArchivo?id=${contents.id}`} modal={200} imagen />
      </Box>

      <CardContent sx={titleStyle}>
        <Typography gutterBottom variant="button" component="div">
          {contents.titulo}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" color="primary" onClick={handleOpen}>
          Leer más
        </Button>
      </CardActions>

      <Modal
        title={contents.titulo}
        information={
          contents.url_pdf === null ? (
            contents.contenido
          ) : (
            <Pdf urlPdf={`${Api.url}getArchivo?id=${contents.id}`} />
          )
        }
        isOpen={modalShow}
        handleClose={handleClose}
      />
    </Card>
  );
}
